import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './PopupAlertModal.css';

interface PopupAlertModalProps {
  message: string;
  onAcknowledge: () => void;
}

const PopupAlertModal: React.FC<PopupAlertModalProps> = ({ message, onAcknowledge }) => {
  const [animate, setAnimate] = useState(false);

  // Handle body scroll lock and Escape key
  useEffect(() => {
    const scrollY = window.scrollY;
    document.body.classList.add('popup-alert-modal-open');
    document.body.style.top = `-${scrollY}px`;
    const timer = setTimeout(() => setAnimate(true), 10);

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onAcknowledge();
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('keydown', handleKeyDown);
      const savedScrollY = document.body.style.top;
      document.body.classList.remove('popup-alert-modal-open');
      document.body.style.top = '';
      window.scrollTo(0, parseInt(savedScrollY || '0', 10) * -1);
    };
  }, [onAcknowledge]);

  return createPortal(
    <>
      <div className={`popup-alert-modal__backdrop ${animate ? 'popup-alert-modal__backdrop--visible' : ''}`} />
      <div className={`popup-alert-modal ${animate ? 'popup-alert-modal--visible' : ''}`} role="dialog" aria-modal="true" aria-label="Store alert">
        <div className="popup-alert-modal__card">
          <button className="popup-alert-modal__close" onClick={onAcknowledge} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="#00443B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          {/* Sweetspot dots logo */}
          <svg className="popup-alert-modal__logo" width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.5" cy="4.08" r="4.08" fill="#04433B"/>
            <circle cx="28.33" cy="12.26" r="4.08" fill="#04433B"/>
            <circle cx="4.67" cy="12.26" r="4.08" fill="#04433B"/>
            <circle cx="23.81" cy="25.49" r="4.08" fill="#04433B"/>
            <circle cx="9.19" cy="25.49" r="4.08" fill="#04433B"/>
          </svg>
          <p className="popup-alert-modal__message">{message}</p>
        </div>
      </div>
    </>,
    document.body
  );
};

export default PopupAlertModal;
